import request from '@/utils/requestYS'
// 民用抄表册分页查询
export function pArumReadingBook_page(params) {
  return request({
    url: '/pArumReadingBook/page',
    method: 'get',
    params
  })
}
// 民用抄表册删除
export function pArumReadingBook_delete(params) {
  return request({
    url: '/pArumReadingBook/delete',
    method: 'get',
    params
  })
}
// 民用抄表册查询单条
export function pArumReadingBook_findById(params) {
  return request({
    url: '/pArumReadingBook/findById',
    method: 'get',
    params
  })
}
// 民用抄表册查询新增-编辑抄表册
export function pArumReadingBook_saveOrUpdate(data) {
  return request({
    url: '/pArumReadingBook/saveOrUpdate',
    method: 'post',
    data
  })
}
// 民用抄表册停用-启用
export function pArumReadingBook_stop(params) {
  return request({
    url: '/pArumReadingBook/stop',
    method: 'get',
    params
  })
}
// 民用抄表册添加用户弹框的用户列表
export function pArumReadingBook_usersPage(params) {
  return request({
    url: '/pArumReadingBook/usersPage',
    method: 'get',
    params
  })
}
// 民用抄表册查看抄表册用户列表
export function pArumReadingBook_usersPageByReadId(params) {
  return request({
    url: '/pArumReadingBook/usersPageByReadId',
    method: 'get',
    params
  })
}

// 非民用抄表册分页查询
export function pBrumReadingBook_page(params) {
  return request({
    url: '/pBrumReadingBook/page',
    method: 'get',
    params
  })
}
// 非民用抄表册删除
export function pBrumReadingBook_delete(params) {
  return request({
    url: '/pBrumReadingBook/delete',
    method: 'get',
    params
  })
}
// 非民用抄表册查询单条
export function pBrumReadingBook_findById(params) {
  return request({
    url: '/pBrumReadingBook/findById',
    method: 'get',
    params
  })
}
// 非民用抄表册查询新增-编辑抄表册
export function pBrumReadingBook_saveOrUpdate(data) {
  return request({
    url: '/pBrumReadingBook/save',
    method: 'post',
    data
  })
}
// 非民用抄表册停用-启用
export function pBrumReadingBook_stop(params) {
  return request({
    url: '/pBrumReadingBook/stop',
    method: 'get',
    params
  })
}
// 非民用抄表册添加用户弹框的用户列表
export function pBrumReadingBook_usersPage(params) {
  return request({
    url: '/pBrumReadingBook/usersPage',
    method: 'get',
    params
  })
}
// 非民用抄表册查看抄表册用户列表
export function pBrumReadingBook_usersPageByReadId(params) {
  return request({
    url: '/pBrumReadingBook/usersPageByReadId',
    method: 'get',
    params
  })
}
// 懒加载树形
export function addressAreaTreeLazy(params) {
  return request({
    url: '/arumAddressArea/addressAreaTreeLazy',
    method: 'get',
    params
  })
}

// 民用app或pc分页查询
export function pArumReadingTask_page(params) {
  return request({
    url: '/pArumReadingTask/page',
    method: 'get',
    params
  })
}
// 民用派工
export function pArumReadingTask_updateReader(data) {
  return request({
    url: '/pArumReadingTask/updateReader',
    method: 'post',
    data
  })
}
// 民用作废
export function pArumReadingTask_cancel(params) {
  return request({
    url: '/pArumReadingTask/cancel',
    method: 'get',
    params
  })
}
// 民用召回
export function pArumReadingTask_callback(params) {
  return request({
    url: '/pArumReadingTask/callback',
    method: 'get',
    params
  })
}
// 民用审核
export function pArumReadingTask_audit(data) {
  return request({
    url: '/pArumReadingTask/audit',
    method: 'post',
    data
  })
}
// 民用催办
export function pArumReadingTask_urging(params) {
  return request({
    url: '/pArumReadingTask/urging',
    method: 'get',
    params
  })
}
// 民用app或pc任务详情，用户分页查询
export function pArumReadingTask_usersPage(params) {
  return request({
    url: '/pArumReadingTask/usersPage',
    method: 'get',
    params
  })
}

// 非民用app或pc分页查询
export function pBrumReadingTask_page(params) {
  return request({
    url: '/pBrumReadingTask/page',
    method: 'get',
    params
  })
}
// 非民用派工
export function pBrumReadingTask_updateReader(data) {
  return request({
    url: '/pBrumReadingTask/updateReader',
    method: 'post',
    data
  })
}
// 非民用作废
export function pBrumReadingTask_cancel(params) {
  return request({
    url: '/pBrumReadingTask/cancel',
    method: 'get',
    params
  })
}
// 非民用召回
export function pBrumReadingTask_callback(params) {
  return request({
    url: '/pBrumReadingTask/callback',
    method: 'get',
    params
  })
}
// 非民用审核
export function pBrumReadingTask_audit(data) {
  return request({
    url: '/pBrumReadingTask/audit',
    method: 'post',
    data
  })
}
// 非民用催办
export function pBrumReadingTask_urging(params) {
  return request({
    url: '/pBrumReadingTask/urging',
    method: 'get',
    params
  })
}
// 非民用app或pc任务详情，用户分页查询
export function pBrumReadingTask_usersPage(params) {
  return request({
    url: '/pBrumReadingTask/usersPage',
    method: 'get',
    params
  })
}
// 转维修，民-非民 通用
export function toMaintenance(params) {
  return request({
    url: '/pArumReadingTask/toMaintenance',
    method: 'get',
    params
  })
}
// 民用-非民用户统计，表具类型统计
export function usersCount(params) {
  return request({
    url: '/pBoard/usersCount',
    method: 'get',
    params
  })
}
// 用气量
export function gasConsumption(params) {
  return request({
    url: '/pBoard/gasConsumption',
    method: 'get',
    params
  })
}
// 开票购气
export function paymentGas(params) {
  return request({
    url: '/pBoard/paymentGas',
    method: 'get',
    params
  })
}
// 实际购气标况总累
export function totalizeRange(params) {
  return request({
    url: '/pBoard/totalizeRange',
    method: 'get',
    params
  })
}
// pc看板抄表相关统计，app看板所有统计
export function statistics(params) {
  return request({
    url: '/pArumReadingTask/statistics',
    method: 'get',
    params
  })
}
// 看板，收费统计
export function countStatics(params) {
  return request({
    url: '/pBoard/countStatics',
    method: 'get',
    params
  })
}
// 民用普表扣费列表页
export function pArumReadingTask_normalPage(params) {
  return request({
    url: '/pArumReadingTask/normalPage',
    method: 'get',
    params
  })
}
// 非民用普表扣费列表页
export function pBrumReadingTask_normalPage(params) {
  return request({
    url: '/pBrumReadingTask/normalPage',
    method: 'get',
    params
  })
}
// 民用普表扣费详情，用户分页
export function pArumReadingTask_normalUsersPage(params) {
  return request({
    url: '/pArumReadingTask/normalUsersPage',
    method: 'get',
    params
  })
}
// 非民用普表扣费详情，用户分页
export function pBrumReadingTask_normalUsersPage(params) {
  return request({
    url: '/pBrumReadingTask/normalUsersPage',
    method: 'get',
    params
  })
}
// 民用-非民 普表扣费,批量扣费,单个扣费
export function paymentNormal(params) {
  return request({
    url: '/pArumReadingTask/paymentNormal',
    method: 'get',
    params
  })
}
// 民用-非民 普表扣费详情
export function paymentNormalDetails(params) {
  return request({
    url: '/pArumReadingTask/paymentNormalDetails',
    method: 'get',
    params
  })
}
// 民用-非民通用 普表扣费,成功接口
export function paymentNormalSuccess(params) {
  return request({
    url: '/pArumReadingTask/paymentNormalSuccess',
    method: 'get',
    params
  })
}
// 导出用户
export function excelUsersPage(params) {
  return request({
    url: '/pArumReadingTask/excelUsersPage',
    method: 'get',
    params,
    responseType: 'blob' //改变接收的值类型
  })
}
// 导出用户
export function excelbUsersPage(params) {
  return request({
    url: '/pBrumReadingTask/excelUsersPage',
    method: 'get',
    params,
    responseType: 'blob' //改变接收的值类型
  })
}
// 导出扣费
export function excelNormalUsersPage(params) {
  return request({
    url: '/pArumReadingTask/excelNormalUsersPage',
    method: 'get',
    params,
    responseType: 'blob' //改变接收的值类型
  })
}
